module.exports = __webpack_public_path__ + "static/ndus.dbefe62b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/ndus.png
// module id = 2192
// module chunks = 61762850755587